import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function OfferStack() {
  return <section className="py-20 px-4 bg-white" data-id="element-111">
      <div className="max-w-5xl mx-auto" data-id="element-112">
        <div className="text-center mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-6" data-id="element-114">
            Today, you're not just getting a guide; you're getting the map back
            to YOURSELF.
          </h2>
          <p className="text-xl text-brown-light font-body" data-id="element-115">
            Here is what's included when you join today:
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center lg:items-start" data-id="element-116">
          <div className="w-full lg:w-1/3" data-id="element-117">
            <div className="sticky top-24" data-id="element-118">
              <img src="https://cdn.magicpatterns.com/uploads/9iRWJgXntauaBbij2iE5Nq/The_woman_90_-_checkout_image.png" alt="The Woman 90 Protocol Bundle" className="w-full h-auto rounded-xl shadow-warm-lg" data-id="element-119" />
            </div>
          </div>

          <div className="w-full lg:w-2/3 space-y-4" data-id="element-120">
            <div className="p-6 rounded-xl border-2 border-gold bg-gold/5 shadow-sm flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between" data-id="element-121">
              <div className="flex items-start gap-4" data-id="element-122">
                <CheckCircle2 className="w-6 h-6 mt-1 flex-shrink-0 text-gold" data-id="element-123" />
                <div data-id="element-124">
                  <h3 className="font-heading font-bold text-xl text-brown" data-id="element-125">
                    The Woman 90 Protocol
                  </h3>
                  <p className="text-brown-light/80 font-body text-sm mt-1" data-id="element-126">
                    The step-by-step system to hack your energy and reclaim your
                    identity.
                  </p>
                </div>
              </div>
              <div className="text-right sm:text-left whitespace-nowrap ml-10 sm:ml-0" data-id="element-127">
                <span className="text-sm text-brown-light/60 uppercase tracking-wider font-bold" data-id="element-128">
                  Value
                </span>
                <p className="font-heading font-bold text-xl text-brown" data-id="element-129">
                  $197
                </p>
              </div>
            </div>

            <div className="mt-8 p-6 bg-brown text-white rounded-xl shadow-warm flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-130">
              <span className="font-heading text-xl md:text-2xl" data-id="element-131">
                TOTAL VALUE:
              </span>
              <span className="font-heading font-bold text-3xl md:text-4xl text-gold" data-id="element-132">
                $197
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}